export { default } from './funds-register-number-text-field';
export * from './funds-register-number-text-field';
